var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.dataReady && _vm.spaces)?_c('my-spaces-child',{attrs:{"spaces":_vm.spaces,"anchors":_vm.anchors,"hobjects":_vm.hobjects,"nodes":_vm.nodes,"labels":_vm.labels,"spaces_labels":_vm.spaces_labels}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }